export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7884.98785e96.jpg";